import React from 'react'
import { glyphs } from './lib'

export type CustomIconName =
  | 'AiBlob'
  | 'LeftSidebar'
  | 'MobileBottomDrawer'
  | 'RightSidebar'

export interface CustomIconProps extends React.SVGProps<SVGSVGElement> {
  name: CustomIconName
}

/**
 * The CustomIcon component is used when there is an icon needed that does
 * not exist in the Material Icons Library.
 */

const CustomIcon = (props: CustomIconProps) => {
  const { className, name, style } = props

  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      {glyphs[name]}
    </svg>
  )
}

CustomIcon.displayName = 'CustomIcon'
export default CustomIcon
